import { isEqual } from 'lodash'
import { actions as undoActions } from '@/store/plugins/undoHistory'

const module = 'OLD_WORKBENCH_TARGET_DEF__'

// attribute actions
export const ADD_ATTRIBUTE = module + 'ADD_ATTRIBUTE'
export const REMOVE_ATTRIBUTE = module + 'REMOVE_ATTRIBUTE'
export const UPDATE_ATTRIBUTE = module + 'UPDATE_ATTRIBUTE'
export const SELECT_ATTRIBUTE = module + 'SELECT_ATTRIBUTE'
export const CLEAR_SELECTION = module + 'CLEAR_SELECTION'
export const CLEAR_DEFINITION = module + 'CLEAR_DEFINITION'
export const SET_DEFINITION = module + 'SET_DEFINITION'
export const SET_DROPPED_ATTRIBUTES_IN_TD = module + 'SET_DROPPED_ATTRIBUTES_IN_TD'
export const MOVE_ATTRIBUTE = module + 'MOVE_ATTRIBUTE'
export const SET_TARGET_HAD_CHANGED = module + 'SET_TARGET_HAD_CHANGED'

// operator actions
export const UPDATE_OPERATOR = module + 'UPDATE_OPERATOR'

// grouping actions
export const GROUP = module + 'GROUP'
export const UNGROUP = module + 'UNGROUP'
export const CREATE_COUNT_GROUP = module + 'CREATE_COUNT_GROUP'
export const REMOVE_COUNT_GROUP = module + 'REMOVE_COUNT_GROUP'

// component state
export const SET_VIEW_ONLY = module + 'SET_VIEW_ONLY'
export const SET_TO_VIEW_ONLY = module + 'SET_TO_VIEW_ONLY'
export const REMOVE_VIEW_ONLY = module + 'REMOVE_VIEW_ONLY'

// drag and drop actions
export const SET_DRAG_DROP_MODE = module + 'SET_DRAG_DROP_MODE'
export const ACTIVATE_DRAG_DROP = module + 'ACTIVATE_DRAG_DROP'
export const DEACTIVATE_DRAG_DROP = module + 'DEACTIVATE_DRAG_DROP'

export const SET_DRAG_ITEM = module + 'SET_DRAG_ITEM'
export const START_DRAG_ITEM = module + 'START_DRAG_ITEM'
export const REMOVE_DRAG_ITEM = module + 'REMOVE_DRAG_ITEM'

// UndoHistory Actions
export const UNDO_TARGET_DEF = module + 'UNDO_TARGET_DEF'
export const REDO_TARGET_DEF = module + 'REDO_TARGET_DEF'
export const INITIALIZE_TARGET_DEF = module + 'INITIALIZE_TARGET_DEF'

export default {
  [UNDO_TARGET_DEF]: (context) => {
    context.dispatch(undoActions.UNDO)
  },
  [REDO_TARGET_DEF]: (context) => {
    context.dispatch(undoActions.REDO)
  },
  [INITIALIZE_TARGET_DEF]: (context, targetDef) => {
    context.dispatch(undoActions.INITIALIZE, targetDef)
  },
  [SET_TO_VIEW_ONLY] ({ commit }) {
    commit(SET_VIEW_ONLY, true)
  },
  [REMOVE_VIEW_ONLY] ({ commit }) {
    commit(SET_VIEW_ONLY, false)
  },
  [SET_DEFINITION] ({ commit }, definition) {
    commit(SET_DEFINITION, definition)
  },
  [ADD_ATTRIBUTE] ({ commit, state }, attribute) {
    if (attribute.options) {
      let selectedAttribute = attribute.options.find((op) => {
        return op.name === attribute.value || isEqual(op.value, attribute.value)
      })
      if (selectedAttribute.type === 'custom') {
        attribute.type = selectedAttribute.type
        attribute.query = selectedAttribute.query
      } else if (selectedAttribute.type === 'query') {
        attribute = selectedAttribute.query
      }
    }
    if (state.viewOnly) return
    commit(SET_TARGET_HAD_CHANGED)
    commit(ADD_ATTRIBUTE, attribute)
  },
  [UPDATE_ATTRIBUTE] ({ commit }, payload) {
    commit(SET_TARGET_HAD_CHANGED)
    commit(UPDATE_ATTRIBUTE, payload)
  },
  [UPDATE_OPERATOR] ({ commit }, payload) {
    commit(SET_TARGET_HAD_CHANGED)
    commit(UPDATE_OPERATOR, payload)
  },
  [REMOVE_ATTRIBUTE] ({ commit, getters }) {
    if (getters.selectedCount > 0) {
      commit(SET_TARGET_HAD_CHANGED)
      commit(REMOVE_ATTRIBUTE)
    }
  },
  [SELECT_ATTRIBUTE] ({ commit, state }, attribute) {
    if (state.viewOnly) return
    commit(SELECT_ATTRIBUTE, attribute)
  },
  [CLEAR_SELECTION] ({ commit }) {
    commit(CLEAR_SELECTION)
  },
  [GROUP] ({ commit, getters }) {
    if (getters.selectedCanBeGrouped) {
      commit(SET_TARGET_HAD_CHANGED)
      commit(GROUP)
    }
  },
  [UNGROUP] ({ commit, getters }) {
    if (getters.selectedCanBeUngrouped) {
      commit(SET_TARGET_HAD_CHANGED)
      commit(UNGROUP)
    }
  },
  [CLEAR_DEFINITION] ({ commit, state }) {
    if (state.viewOnly) {
      return
    } else {
      commit(SET_TARGET_HAD_CHANGED)
      commit(CLEAR_DEFINITION)
    }
  },
  // drag and drop actions
  [SET_DRAG_DROP_MODE] ({ commit }, newState) {
    commit(SET_DRAG_DROP_MODE, newState)
  },
  [ACTIVATE_DRAG_DROP] ({ commit }) {
    commit(CLEAR_SELECTION)
    commit(SET_DRAG_DROP_MODE, true)
  },
  [DEACTIVATE_DRAG_DROP] ({ commit }) {
    commit(SET_DRAG_DROP_MODE, false)
  },
  [START_DRAG_ITEM] ({commit}, value) {
    commit(SET_DRAG_ITEM, value)
  },
  [REMOVE_DRAG_ITEM] ({ commit }) {
    commit(SET_DRAG_ITEM, null)
  },
  [MOVE_ATTRIBUTE] ({ commit }, value) {
    commit(SET_TARGET_HAD_CHANGED)
    commit(MOVE_ATTRIBUTE, value)
  },
  [CREATE_COUNT_GROUP] ({ commit }, value) {
    commit(CREATE_COUNT_GROUP, value)
    commit(CLEAR_SELECTION)
  },
  [REMOVE_COUNT_GROUP] ({commit}, value) {
    commit(REMOVE_COUNT_GROUP, value)
    commit(CLEAR_SELECTION)
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/targetDefinition/store/actions.js